import { defineMessages } from 'react-intl'

export const messages = defineMessages({
  write_address: { id: 'towingRecord.write_address', defaultMessage: 'Enter address' },
  job_end_success_message: { id: 'towingRecord.end.success.notification.message', defaultMessage: 'Job ended' },
  job_end_success_title: { id: 'towingRecord.end.success.notification.title', defaultMessage: 'Success' },
  job_end_error_message: { id: 'towingRecord.end.success.notification.message', defaultMessage: 'Job ended' },
  job_end_error_title: { id: 'towingRecord.end.success.notification.title', defaultMessage: 'Success' },
})
